import { create } from 'zustand'

export type ScoreState = {
  isGuessedActive: boolean
  isNotGuessedActive: boolean
  isSnoozeActive: boolean
}

const defaultScoreState: ScoreState = {
  isGuessedActive: false,
  isNotGuessedActive: false,
  isSnoozeActive: false,
}

type ScoreActions = {
  clean: () => void
  setIsGuessedActive: (isGuessedActive: boolean) => void
  setIsNotGuessedActive: (isNotGuessedActive: boolean) => void
  setIsSnoozeActive: (isSnoozeActive: boolean) => void
}

export const useScoreStore = create<ScoreState & ScoreActions>()(set => ({
  ...defaultScoreState,
  clean: () => set(defaultScoreState),
  setIsGuessedActive: isGuessedActive => set({ isGuessedActive }),
  setIsNotGuessedActive: isNotGuessedActive => set({ isNotGuessedActive }),
  setIsSnoozeActive: isSnoozeActive => set({ isSnoozeActive }),
}))
